import { render, staticRenderFns } from "./TheProfileFieldFile.vue?vue&type=template&id=60ba98ae&"
import script from "./TheProfileFieldFile.vue?vue&type=script&lang=js&"
export * from "./TheProfileFieldFile.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileFieldFile.vue?vue&type=style&index=0&id=60ba98ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports